import React from 'react';
import { MessageSquare } from 'lucide-react';

interface ScalePanelProps {
  onChatOpen: () => void;
}

export function ScalePanel({ onChatOpen }: ScalePanelProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-2xl font-bold text-gray-900">
        Groei Zonder Compromissen
      </h3>
      <p className="text-gray-600">
        Verwerk duizenden klantgesprekken tegelijk met behoud van kwaliteit. Onze AI-oplossing groeit mee met uw organisatie, zodat u nooit hoeft te kiezen tussen schaalgrootte en servicekwaliteit.
      </p>
      <button 
        onClick={onChatOpen}
        className="mt-4 bg-brand-500 text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-brand-600 transition-colors inline-flex items-center gap-2"
      >
        Start Direct <MessageSquare size={18} />
      </button>
    </div>
  );
}